import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    background: {
      default: '#F7F7F7',
    },
    primary: {
      main: '#1D4F91',
      contrastText: '#FFF',
    },
    secondary: {
      main: '#FFA700',
      contrastText: '#212C5A',
    },
    text: {
      secondary: '#707070',
    },
  },
  overrides: {
    MuiInputLabel: {
      root: {
        fontSize: '.8rem',
      },
    },
  },
});
export default theme;
